module.exports = __webpack_public_path__ + "img/item6.1fe99040.png";